import React, {useState} from 'react';
import Row from "../UI/Row";
import ButtonBlack from "../UI/ButtonBlack";
import Button from "../UI/Button";
import subscriptions from "../../utilities/data/products";
import {useRegistrationSteps} from "../../utilities/context/registration-steps/registration-steps-context";
import SubscriptionRadio from "./SubscriptionRadio";

const packageTypes = {
    base: "base",
    dynamic: "dynamic"
}

const Step2 = ({onConfirm}) => {

    const {selectedSubscription, selectSubscription, user, setStep} = useRegistrationSteps();

    const trialClick = () => {
        if (selectedSubscription.id === subscriptions.base.id)
            selectSubscription(subscriptions.trial_base);
        else
            selectSubscription(subscriptions.trial_dynamic);

        setStep(3);
    }

    const purchaseClick = () => {
        if(selectedSubscription.trial) {
            if(selectedSubscription.id === subscriptions.trial_base.id) {
                selectSubscription(subscriptions.base);
            }
            if(selectedSubscription.id === subscriptions.trial_dynamic.id) {
                selectSubscription(subscriptions.dynamic);
            }
        }
        if(selectedSubscription.id) {
            setStep(3);
        }
    }

    return (
        <div>
            {user && <div className="mb-4">Ciao <span className="font-bold">{user.name}!</span></div>}
            <div className="mb-4">Scegli L'ABBONAMENTO che fa per te per iniziare ad usare <span
                className="font-bold">ediliziAPP</span></div>

            <Row className="w-full justify-around mb-8">
                <SubscriptionRadio name="BASE"
                                   selected={selectedSubscription.id === subscriptions.base.id || selectedSubscription.id === subscriptions.trial_base.id}
                                   subscription={subscriptions.base}
                                   onClick={() => selectSubscription(subscriptions.base)}/>
                <SubscriptionRadio name="dinamico"
                                   selected={selectedSubscription.id === subscriptions.dynamic.id || selectedSubscription.id === subscriptions.trial_dynamic.id}
                                   subscription={subscriptions.dynamic}
                                   onClick={() => selectSubscription(subscriptions.dynamic)}
                                   bgColor="ea_green_from"
                                   textColor="white"/>
            </Row>


            <Row className="w-full gap-4 flex-col md:flex-row">
                <ButtonBlack className="flex-1"
                             onClick={trialClick}>SCEGLI LA PROVA GRATUITA DI 15 GIORNI</ButtonBlack>
                <Button onClick={purchaseClick} className="flex-1">Acquista abbonamento completo</Button>
            </Row>
        </div>
    );
};

export default Step2;